<template>
  <div>
    <Table
      ref="selection"
      border
      :loading="loading"
      :columns="insideColumns"
      :data="insideTableData"
      @on-select="handleSelect"
      @on-select-all="handleSelectAll"
      @on-selection-change="handleSelectChange"
    ></Table>
  </div>
</template>
<script>
import TablesEdit from './edit.vue'
import './index.less'
export default {
  name: 'Tables',
  props: {
    value: {
      type: Array,
      default: []
    },
    columns: {
      type: Array,
      default: []
    },
    loading: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      insideColumns: [],
      insideTableData: [],
      edittingText: '',
      edittingCellId: ''
    }
  },
  methods: {
    handleSelect (selection, row) {
      // selection 选择了哪些
      // row 当前选择
      if (row.id) {

      }
      this.$emit('on-select', selection, row)
    },
    handleSelectAll (selection) {
      this.$emit('on-select-all', selection)
    },
    handleSelectChange (selection) {
      this.$emit('on-selection-change', selection)
    },
    handleTableData () {
      this.insideTableData = this.value.map((item, index) => {
        let res = item
        res.initRowIndex = index
        return res
      })
    },
    handleColumns (columns) {
      this.insideColumns = columns.map((item, index) => {
        let res = item
        return res
      })
    }
  },
  watch: {
    columns (columns) {
      this.handleColumns(columns)
    },
    value (val) {
      this.handleTableData()
    }
  },
  mounted () {
    this.handleColumns(this.columns)
    this.handleTableData()
  }
}
</script>
